import { combineReducers, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import reduxStorage from 'redux-persist/lib/storage';
import { loader, notify, user,ticker,refresh, refreshLoan, refreshBorrow, refreshSecMaster, refreshCpty, cptyData } from './reducers';

const persistConfig = {
  key: 'root',
  storage: reduxStorage,
  whitelist: ['user','refresh', 'refreshLoan', 'refreshBorrow', 'refreshSecMaster', 'refreshCpty','cptyData']
};

const persistedReducer = persistReducer(
  persistConfig,
  combineReducers({
    loader,
    notify,
    user,
    ticker,
    refresh,
    refreshLoan,
    refreshBorrow,
    refreshSecMaster,
    refreshCpty,
    cptyData
  })
);

export const store = createStore(persistedReducer);
export const persistor = persistStore(store);